<script>
	import { browser } from '$app/environment';
	import { goto } from '$app/navigation';
	import { page } from '$app/state';
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import {
		handleFormSubmit,
		sendPixelConversions,
	} from '$lib/PageSections/Forms/formUtils';
	import toast from 'svelte-french-toast';
	import { fly } from 'svelte/transition';
	import SuperDebug, { superForm } from 'sveltekit-superforms';
	import { valibotClient } from 'sveltekit-superforms/adapters';

	let {
		form = $bindable(),
		formData = null,
		resetForm = true,
		enctype = null,
		taintedMessage = null,
		class: className = null,
		data = null,
		formName,
		disabled = null,
		schema,
		innerForm = $bindable(),
		buttonText = 'Submit',
		taintedButton = false,
		invalidateAll = 'force',
		sendPixelEvents = null,
		action,
		children,
		debug = null,
		buttonCenter = null,
	} = $props();
	let loading = $state(false);

	function getForm({ schema, initialFormData, invalidateAll }) {
		return superForm(initialFormData, {
			invalidateAll: invalidateAll,
			taintedMessage,
			resetForm,
			validators: valibotClient(schema),
			onSubmit({ formData }) {
				loading = true;
				formData.set('url', page.url?.toString());
				handleFormSubmit(formData, page.url);
			},
			onResult() {
				loading = false;
			},
			onUpdated({ form }) {
				if (!form.valid) {
					if (form.message?.text) {
						toast.error(form.message.text);
					}
				}
				if (form.valid) {
					if (form.message?.text) {
						toast.success(form.message.text);
					}
					if (sendPixelEvents && form.message.normalizedData) {
						sendPixelConversions(form.message.normalizedData);
					}
					if (form.message.successUrl) {
						if (form.message.hardRedirect) {
							window.location = form.message.successUrl;
						} else {
							goto(form.message.successUrl);
						}
					}
				}
			},
			onError({ result }) {
				toast.error(result?.error?.message);
				$message = result?.error?.message;
			},
		});
	}

	const initialFormData =
		data?.forms?.[formName] ?? formData ?? valibotClient(schema);

	form = getForm({ schema, initialFormData, invalidateAll });
	const { message, enhance, tainted, isTainted, errors, formId } = form;
	innerForm = form.form;
</script>

{#if debug}
	<SuperDebug data={innerForm} />
{/if}
<form
	name="lead"
	method="POST"
	{enctype}
	use:enhance
	{action}
	class={[
		'row-auto mb-4 grid w-full grid-cols-1 gap-x-4 last:mb-0 md:grid-cols-2',
		className,
	]}
>
	<input type="hidden" name="__superform_id" bind:value={$formId} />
	{@render children({
		form,
		disabled,
		loading,
		errors: $errors,
		message: $message?.text ?? $message,
		tainted: !browser || isTainted($tainted),
	})}

	<span class="@container col-span-full grid w-full">
		{#if $message || $errors?._errors}
			<div
				transition:fly={{ y: '-50%' }}
				class={[
					'row-start-2 flex min-h-12 w-full @md:w-auto',
					{ '@sm:row-start-1': !buttonCenter },
				]}
			>
				{#if $message}
					<p
						transition:fly={{ y: '-50%' }}
						class:!text-indow-green={page.status == 200}
						class:!text-indow-red={page.status >= 400}
						class="mb-0 w-full self-center pr-2 text-left @md:w-auto"
					>
						{$message?.text ?? $message}
					</p>
				{/if}
				{#if $errors?._errors}
					<p
						transition:fly={{ y: '-50%' }}
						class="text-indow-red mb-0 w-full self-center pr-2 text-left @md:w-auto"
					>
						{$errors?._errors}
					</p>
				{/if}
			</div>
		{/if}
		<div
			class={[
				'row-start-1 min-h-12 w-full @md:w-auto @md:max-w-fit',
				{ 'place-self-end': !buttonCenter },
				{ 'place-self-center': buttonCenter },
			]}
		>
			<Button
				class="mb-0 w-full place-self-end"
				buttonType="button"
				{loading}
				active={taintedButton ? isTainted($tainted) || !browser : true}
				{disabled}>{buttonText}</Button
			>
		</div>
	</span>
</form>
